export default __webpack_public_path__ + "static/media/hand-light.48acbe52.svg";